/* eslint-disable */
import React, { useState, useEffect, useContext, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Row } from 'react-flexbox-grid'
import { PageTitle, PageSubtitle, TooltipHintWrapper, PageSubtitleWrapper } from 'flow/SiteProposal/pages/About/style'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import Container from 'components/Container'
import Col from 'components/Col'
import Select from 'components/Select/selectAbout'
import RadioButton from 'components/RadioButton'
import InfoSmallIcon from 'assets/icons/info-small-icon'
import ActionSelectorCard from './ActionSelectorCard'
import { MonitoringContext } from 'providers/monitoring'
import Loader from 'components/Loader'
import { StyledRow, TooltipWrapper, TopMarginDiv } from './style'
import {
  getResponseDesignation,
  getResponseAction,
  getResponsePlanning,
  getResponseLevelOneAction,
  getResponseLevelTwoAction,
  requestSiteResponse,
  getMonitoringResponseActionsBySiteResponse,
  getResponseLevelThreeAction
} from 'api/monitoring'
import Textarea from 'components/Textarea'

const MonitoringResponsePage = () => {
  const params = useParams()
  const monitoringId = params?.monitoringId
  const [selectedDesignation1, setSelectedDesignation1] = useState('')
  const [selectedDesignation2, setSelectedDesignation2] = useState('')
  const [planningOption, setPlanningOption] = useState(null)
  const [actionOption, setActionOption] = useState()
  const [designationOptions, setDesignationOptions] = useState([])
  const [planningOptions, setPlanningOptions] = useState([])
  const [responseActionOptions, setResponseActionOptions] = useState([])
  const [level1Options, setLevel1Options] = useState([])
  const [level2Options, setLevel2Options] = useState([])
  const [level3Options, setLevel3Options] = useState([])
  const {
    siteResponseRecord,
    setSiteResponseRecord,
    updateSiteResponse,
    monitoringProposalFieldValidation,
    isEditable
  } = useContext(MonitoringContext)
  const [monitorResponseActionsData, setMonitorResponseActionsData] = useState()
  const [optionsLoaded, setOptionsLoaded] = useState(false)
  const [responseLoaded, setResponseLoaded] = useState(false)
  const saveTimeoutRef = useRef(null)
  const [furtherDetails, setFurtherDetails] = useState('')
  const normalize = (res) => {
    if (Array.isArray(res)) return res
    if (Array.isArray(res?.data)) return res.data
    if (Array.isArray(res?.data?.data)) return res.data.data
    return []
  }
  const FURTHER_DETAILS_MAX = 255

  useEffect(() => {
    async function fetchAllData() {
      try {
        const [designationRes, planningRes, actionRes, level1Res, level2Res, level3Res] = await Promise.all([
          getResponseDesignation(),
          getResponsePlanning(),
          getResponseAction(),
          getResponseLevelOneAction(),
          getResponseLevelTwoAction(),
          getResponseLevelThreeAction()
        ])
        const designationData = normalize(designationRes)
        const planningData = normalize(planningRes)
        const actionData = normalize(actionRes)
        const level1Data = normalize(level1Res)
        const level2Data = normalize(level2Res)
        const level3Data = normalize(level3Res)
        setDesignationOptions(designationData.map((i) => ({ label: i.name, value: i.id })))
        setPlanningOptions(planningData.map((i) => ({ label: i.name, value: i.id })))
        setResponseActionOptions(actionData.map((i) => ({ label: i.name, value: i.id })))
        setLevel1Options(level1Data.map((i) => ({ label: i.name, value: i.id })))
        setLevel2Options(level2Data.map((i) => ({ label: i.name, value: i.id, level1_id: i.level1_actions_id })))
        setLevel3Options(level3Data.map((i) => ({ label: i.name, value: i.id, level2_id: i.level2_actions_id })))
        setOptionsLoaded(true)
      } catch (err) {
        console.error(' API Fetch Error:', err)
        setOptionsLoaded(true)
      }
    }
    fetchAllData()
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const postResponse = await requestSiteResponse(Number(monitoringId))
        setSiteResponseRecord(postResponse)
        setResponseLoaded(true)
      } catch (e) {
        console.error(e)
        setResponseLoaded(true)
      }
    }
    fetchData()
  }, [])

  const isLoading = !(optionsLoaded && responseLoaded)

  useEffect(() => {
    if (siteResponseRecord) {
      setSelectedDesignation1(siteResponseRecord?.designation_pa_id ? siteResponseRecord?.designation_pa_id : '')
      setSelectedDesignation2(siteResponseRecord?.designation_oecms_id ? siteResponseRecord?.designation_oecms_id : '')
      const initialPlanning = planningOptions.find((opt) => opt.value === siteResponseRecord?.response_planning_id)
      setPlanningOption(initialPlanning || null)
      const initialAction = responseActionOptions.find((opt) => opt.value === siteResponseRecord?.response_action_id)
      setActionOption(initialAction || null)
      setFurtherDetails(siteResponseRecord?.provide_further_details || '')
    }
  }, [siteResponseRecord?.id, planningOptions, responseActionOptions])

  useEffect(() => {
    const loadInitialActions = async () => {
      if (!siteResponseRecord?.id) {
        return
      }
      try {
        const monitorRes = await getMonitoringResponseActionsBySiteResponse(siteResponseRecord?.id, monitoringId)
        setMonitorResponseActionsData(monitorRes)
      } catch (error) {
        console.error(error)
      }
    }
    loadInitialActions()
  }, [siteResponseRecord?.id])

  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
    }
  }, [])

  const scheduleSave = (field, value, ms = 300) => {
    if (!updateSiteResponse) return
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }
    saveTimeoutRef.current = setTimeout(() => {
      updateSiteResponse(siteResponseRecord?.id, { [field]: value })
    }, ms)
  }
  const handleDesignation1Change = async (designation) => {
    setSelectedDesignation1(designation)
    scheduleSave('designation_pa_id', designation)
  }
  const handleDesignation2Change = async (designation) => {
    setSelectedDesignation2(designation)
    scheduleSave('designation_oecms_id', designation)
  }
  const handlePlanningChange = async (option) => {
    setPlanningOption(option)
    scheduleSave('response_planning_id', option.value)
  }
  const handleActionChange = async (option) => {
    setActionOption(option)
    scheduleSave('response_action_id', option.value)
  }
  const onFurtherDetailsChange = async (e) => {
    const val = e.target.value || ''
    const truncated = val.slice(0, FURTHER_DETAILS_MAX)
    setFurtherDetails(truncated)
    scheduleSave('provide_further_details', truncated, 500)
  }

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
        <Loader />
      </div>
    )
  }

  const commonCardProps = {
    optionsOne: level1Options,
    optionsTwo: level2Options,
    optionsThree: level3Options,
    siteResponseId: Number(siteResponseRecord?.id),
    monitorResponseActionsData: monitorResponseActionsData,
    isEditable: isEditable
  }

  const commonTooltipProps = {
    style: { zIndex: 1000 },
    placement: 'bottom',
    trigger: ['hover'],
    align: { offset: [0, 16] },
    type: 'big'
  }

  return (
    <div>
      <PageTitle data-test="legend">
        <FormattedMessage id="responseEvaluationTitle" />
      </PageTitle>
      <PageSubtitleWrapper>
        <PageSubtitle data-test="sub-legend">
          <FormattedMessage id="provideConservationDetails" />
        </PageSubtitle>
        <Tooltip
          {...commonTooltipProps}
          overlay={{
            label: 'responseTitle',
            infoTooltip: 'provideMonitoringDetails'
          }}
        >
          <TooltipHintWrapper>
            <InfoIcon />
          </TooltipHintWrapper>
        </Tooltip>
      </PageSubtitleWrapper>
      <Container>
        <StyledRow>
          <Col md={8} mdOffset={2}>
            <TooltipWrapper>
              <FormattedMessage id="coverageByProtectedAreas" />
              <Tooltip
                {...commonTooltipProps}
                overlay={{
                  label: 'coverageByProtectedAreas',
                  infoTooltip: 'protectedAreas'
                }}
              >
                <TooltipHintWrapper>
                  <InfoSmallIcon />
                </TooltipHintWrapper>
              </Tooltip>
            </TooltipWrapper>
            <TopMarginDiv>
              {designationOptions.map((option) => (
                <RadioButton
                  key={option.value}
                  name="designation1"
                  value={option.value}
                  label={option.label}
                  checked={selectedDesignation1 === option?.value}
                  onChange={handleDesignation1Change}
                  notNull={true}
                  disabled={!isEditable || selectedDesignation1}
                />
              ))}
            </TopMarginDiv>
          </Col>
        </StyledRow>
        <StyledRow>
          <Col md={8} mdOffset={2}>
            <TooltipWrapper>
              <FormattedMessage id="coverageByOecms" />
              <Tooltip
                {...commonTooltipProps}
                overlay={{
                  label: 'coverageByOecms',
                  infoTooltip: 'conservationMeasures'
                }}
              >
                <TooltipHintWrapper>
                  <InfoSmallIcon />
                </TooltipHintWrapper>
              </Tooltip>
            </TooltipWrapper>
            <TopMarginDiv>
              {designationOptions.map((option) => (
                <RadioButton
                  key={option.value}
                  name="designation2"
                  value={option.value}
                  label={option.label}
                  checked={selectedDesignation2 === option?.value}
                  onChange={handleDesignation2Change}
                  notNull={true}
                  disabled={!isEditable || selectedDesignation2}
                />
              ))}
            </TopMarginDiv>
          </Col>
        </StyledRow>
        <StyledRow>
          <Col md={8} mdOffset={2}>
            <Select
              placeholder="selectManagementPlanning"
              infoTooltip="managementPlanningInfo"
              label="managementPlanningTitle"
              options={planningOptions}
              value={planningOption}
              onChange={handlePlanningChange}
              field="response_planning_id"
              blueBg={true}
              disabled={!isEditable}
              error={
                monitoringProposalFieldValidation?.siteResponse?.response_planning_id
                  ? { field: '', error: '' }
                  : {
                      field: 'response_planning_id',
                      error: 'pleaseCompleteThisField'
                    }
              }
            />
          </Col>
        </StyledRow>
        <StyledRow>
          <Col md={8} mdOffset={2}>
            <Select
              placeholder="selectConservationAction"
              label="conservationActionsTitle"
              infoTooltip="conservationActionTest"
              options={responseActionOptions}
              value={actionOption}
              onChange={handleActionChange}
              field="response_action_id"
              blueBg={true}
              disabled={!isEditable}
              error={
                monitoringProposalFieldValidation?.siteResponse?.response_action_id
                  ? { field: '', error: '' }
                  : {
                      field: 'response_action_id',
                      error: 'pleaseCompleteThisField'
                    }
              }
            />
          </Col>
        </StyledRow>
        <Row>
          <Col md={8} mdOffset={2}>
            <TooltipWrapper>
              <FormattedMessage id="conservationActionsUnderwayAndNeeded" />
              <Tooltip
                {...commonTooltipProps}
                overlay={{
                  label: 'conservationActionsUnderwayAndNeeded',
                  infoTooltip: 'conservationActionsUnderwayAndNeededInfo'
                }}
              >
                <TooltipHintWrapper>
                  <InfoSmallIcon />
                </TooltipHintWrapper>
              </Tooltip>
            </TooltipWrapper>
          </Col>
        </Row>
        <StyledRow>
          <Col md={8} mdOffset={2}>
            <ActionSelectorCard {...commonCardProps} labelText="conservationActionsUnderway" type="action-underway" />
            {!monitoringProposalFieldValidation?.siteResponse?.actions_underway_count && (
              <div style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '10px', marginBottom: '40px' }}>
                <FormattedMessage id="pleaseCompleteThisField" />
              </div>
            )}
          </Col>
        </StyledRow>

        <StyledRow>
          <Col md={8} mdOffset={2}>
            <ActionSelectorCard {...commonCardProps} labelText="conservationActionsNeeded" type="action-needed" />
            {!monitoringProposalFieldValidation?.siteResponse?.actions_needed_count && (
              <div style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '10px', marginBottom: '40px' }}>
                <FormattedMessage id="pleaseCompleteThisField" />
              </div>
            )}
          </Col>
        </StyledRow>
        <StyledRow>
          <Col md={8} mdOffset={2}>
            <div style={{ position: 'relative' }}>
              <Textarea
                label="furtherDetails"
                value={furtherDetails}
                field="furtherDetails"
                onChange={onFurtherDetailsChange}
                placeholder="furtherDetailsPlaceholder"
                height="128px"
                dataTest="reviewers-text-area"
                isOptional={true}
                disabled={!isEditable}
                marginBottom="0"
                maxLength={FURTHER_DETAILS_MAX}
                infoTooltip="furtherDetailsPlaceholder"
                showCharCount={true}
              />
            </div>
          </Col>
        </StyledRow>
      </Container>
    </div>
  )
}
export default MonitoringResponsePage
